<template>
  <iModal
    v-if="show"
    :close-on-backdrop="false"
    :close-on-escape="false"
    :max-width="600"
    title="Url Options"
    @close="$emit('close')"
  >
    <template #body>
      <DestinationPicker
        :publication-id="publicationId"
        :open-in-new-tab="linkData.openInNewTab"
        :link-value="linkData.linkValue"
        :link-type="linkData.linkType"
        :link-text="linkData.linkText"
        @invalid-url="invalidUrl = $event"
        @update="$emit('update', {...linkData, ...$event})"
      />
    </template>
    <template #footer>
      <iRow vertical-align="middle" align="between" wrap="nowrap">
        <iIcon v-if="originalLinkValue" icon="trash" @click="handleRemove" />
        <iSpace v-else />
        <iRow width="hug" vertical-align="middle" gap="extraSmall">
          <iButton variant="tertiary" @click="$emit('close')">
            Cancel
          </iButton>
          <iButton
            variant="primary"
            :disabled="!linkData.linkValue || invalidUrl"
            @click="handleUpdate"
          >
            Apply
          </iButton>
        </iRow>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import DestinationPicker from "%/components/DestinationPicker.vue";
import { richTextToolRegistry } from "@vcl";

export default {
  name: "RichTextDestinationPickerModal",
  components: { DestinationPicker },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: false,
    },
    originalLinkValue: {
      type: String,
      default: "",
      required: false,
    },
    publicationId: {
      type: Number,
      required: true,
    },
    linkData: {
      type: Object,
      required: true,
    },
    richTextRef: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "update"],
  data() {
    return {
      invalidUrl: true,
    };
  },
  methods: {
    handleUpdate() {
      const elementRef = this.richTextRef;
      const commands = elementRef.commands;
      const newLink = new richTextToolRegistry.linkTool();
      if (this.linkData.linkValue !== this.originalLinkValue) {
        newLink.setTrackingUrl("");
      }
      newLink.url = this.linkData.linkValue;
      newLink.openInNewTab = this.linkData.openInNewTab;
      newLink.linkType = this.linkData.linkType;
      const toolWithText = Object.create(newLink);
      if (this.linkData.linkText && this.linkData.linkText.trim()) {
        toolWithText.linkText = this.linkData.linkText;
        toolWithText.cursorPosition = this.linkData.cursorPosition;
        // The range captured when this modal opened. Opening the modal moves
        // focus out of the editor and collapses its live selection, so without
        // this the editor inserts a second copy of the link text instead of
        // linking the words the user selected.
        toolWithText.selectionRange = this.linkData.selectionRange;
      }

      commands.applyFormatting(toolWithText);
      this.$emit("close");
    },
    handleRemove() {
      const elementRef = this.richTextRef;
      const commands = elementRef.commands;
      const newLink = new richTextToolRegistry.linkTool();
      newLink.setUrl("");
      newLink.setOpenInNewTab(false);
      newLink.setReplaceValue(false);
      commands.applyFormatting(newLink);
      this.$emit("close");
    },
  },
  styleGuide: () => ({}),
};
</script>

<style scoped lang="scss">

</style>
